import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["children", "group"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext, useEffect, useRef } from 'react';
import { MatchHeightContext } from "../../../context/matchheight.context";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MatchHeightElementElement = function MatchHeightElementElement(_ref) {
  var children = _ref.children,
    context = _ref.context,
    group = _ref.group,
    _ref$flex = _ref.flex,
    flex = _ref$flex === void 0 ? false : _ref$flex,
    _ref$valign = _ref.valign,
    valign = _ref$valign === void 0 ? 'top' : _ref$valign,
    _ref$halign = _ref.halign,
    halign = _ref$halign === void 0 ? 'left' : _ref$halign;
  var wrapperRef = useRef(null);
  var childRef = useRef(null);
  useEffect(function () {
    if (context !== null && context !== void 0 && context.register) {
      context.register(group, wrapperRef.current, childRef.current);
    }
    var wrapperCurrent = wrapperRef.current;
    var childCurrent = childRef.current;
    return function () {
      if (context !== null && context !== void 0 && context.unregister) {
        context.unregister(group, wrapperCurrent, childCurrent);
      }
    };
  }, [context, group, wrapperRef, childRef]);
  return /*#__PURE__*/_jsx("div", {
    ref: wrapperRef,
    style: {
      display: flex ? 'flex' : 'block',
      justifyContent: flex && halign === 'center' ? 'center' : halign === 'left' ? 'flex-start' : 'flex-end',
      alignItems: flex && valign === 'center' ? 'center' : valign === 'top' ? 'flex-start' : 'flex-end'
    },
    children: /*#__PURE__*/_jsx("div", {
      style: {
        flex: 1
      },
      ref: childRef,
      children: children
    })
  });
};
export var MatchHeightElement = function MatchHeightElement(_ref2) {
  var children = _ref2.children,
    group = _ref2.group,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var context = useContext(MatchHeightContext);
  if (!context || (context === null || context === void 0 ? void 0 : context.bypassType) === 'stacked') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(MatchHeightElementElement, _objectSpread({
    context: context,
    children: children,
    group: group
  }, restProps));
};